import { Box, Typography } from "@mui/material";

interface ProcessListProps {
    data: {
        id: string;
        name: string;
    }[];
    title: string;
}

const ProcessList = ({
    data,
    title,
}: ProcessListProps) => {
  return (
    <Box flexGrow={1}>
      <Typography variant="h3" mb={1}>
        {title}
      </Typography>
      {data && data.length > 0 ? (
        data.map((process) => (
          <Box
            key={process.id}
            mb={1}
            p={2}
            border="1px solid #e0e0e0"
            borderRadius={1}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              "&:hover": {
                bgcolor: "#f5f5f5",
              },
            }}
          >
            <Box>
              <Typography variant="body1" fontWeight={500}>
                {process.name}
              </Typography>
            </Box>
          </Box>
        ))
      ) : (
        <Typography variant="body2" color="textSecondary" py={2}>
          {`ไม่มีข้อมูล ${title}`}
        </Typography>
      )}
    </Box>
  );
};

export default ProcessList;
